export default __webpack_public_path__ + "static/media/video_hook_and_introduction.c8540920.svg";